import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from '../Axiosinstance';
import Header from './Header';
import { Modal, Button } from 'react-bootstrap';
import { FaPlus } from 'react-icons/fa';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PhoneInput from 'react-phone-input-2'
 
 import {
  TextField,IconButton,InputAdornment
} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import 'react-phone-input-2/lib/material.css'

function NewFacilitator({ onFormSubmit }) {
  const navigate = useNavigate();
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
const [showPassword, setShowPassword] = useState(false);
  const [facilitator, setFacilitator] = useState({
    salutation: '',
    nric: '',
    email: '',
    phone: '',
    educational_level: '',
    qualification: '',
    domain: '',
    gender: '',
    password: '',
    name: '',
    usertype: '',
    prooftype: '',
  });
  const [error, setError] = useState('');

  const [errors, setErrors] = useState({
    salutation: '',
    nric: '',
    email: '',
    phone: '',
    educational_level: '',
    qualification: '',
    domain: '',
    gender: '',
    password: '',
    name: '',
    usertype: '',
    prooftype: '',
  });


  const {
    salutation,
    nric,
    email,
    phone,
    educational_level,
    qualification,
    domain,
    gender,
    password,
    name,
    usertype,
    prooftype,
  } = facilitator;


  const validateNRIC = (id, proofType) => {
    if (proofType === 'NRIC') {
      const nricRegex = /^[A-Z]\d{7}[A-Z]$/;
      return nricRegex.test(id);
    } else if (proofType === 'FIN') {
      const finRegex = /^[A-Z]\d{7}[A-Z]$/;
      return finRegex.test(id);
    }
    return false; // Default return false if the proofType is neither NRIC nor FIN
  };

  const [emailError, setEmailError] = useState('');

  const checkEmailExists = async (email) => {
    console.log(email + "email")
    try {
      const response = await axios.get(`/home/check-email`, {
        params: { email }
      });
      return response.data; // Assume backend returns { available: true } if email is not in use
    } catch (error) {
      console.error('Error checking email:', error);
      return false;
    }
  };

  const onInputChange = (e) => {
    const { name, value } = e.target;

    // Update the facilitator state
    setFacilitator({ ...facilitator, [name]: value });


    // Clear the error message for the specific field
    setErrors({ ...errors, [name]: '' });
  };

  const onSubmit = async (e) => {
    e.preventDefault();

    // Validate the form fields
    const validationErrors = {};


    if (!validateNRIC(nric, prooftype)) {
      validationErrors.nric = `Invalid ${prooftype} format`;
    }

    if (!salutation) {
      validationErrors.salutation = 'Salutation is required';
    }

    if (!name) {
      validationErrors.name = 'Name is required';
    }

    // if (!usertype) {
    //   validationErrors.usertype = 'User Type is required';
    // }

    if (!email) {
      validationErrors.email = 'Email is required';
    }

    if (!phone) {
      validationErrors.phone = 'Phone is required';
    }

    // if (!educational_level) {
    //   validationErrors.educational_level = 'Educational Level is required';
    // } else if (educational_level.length > 50) {
    //   validationErrors.educational_level = 'Educational Level should be 30 characters maximum';
    // }

    if (!qualification) {
      validationErrors.qualification = 'Qualification is required';
    } else if (qualification.length > 50) {
      validationErrors.qualification = 'Qualification should be 30 characters maximum';
    }

    // if (!domain) {
    //   validationErrors.domain = 'Domain is required';
    // } else if (domain.length > 50) {
    //   validationErrors.domain = 'Domain should be 30 characters maximum';
    // }

    if (!gender) {
      validationErrors.gender = 'Gender is required';
    }

    if (!password) {
      validationErrors.password = 'Password is required';
    }
    if (!prooftype) {
      validationErrors.prooftype = 'Proof Type is required';
    }

    // Check if the email already exists if no validation errors
    const emailAvailable = await checkEmailExists(email);
    if (!emailAvailable) {
      validationErrors.email = 'Email is already in use';
      setErrors((prevErrors) => ({
        ...prevErrors,
        email: 'Email is already in use', // Set email error if already in use
      }));
      return;
    }

    // If there are validation errors, update the state and return
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    {
      // Your logic for adding a facilitator here

      // Displaying the toast message
      toast.success("Facilitator added successfully!", {
        position: "top-right",
        autoClose: 3000, // 3 seconds
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    };


    axios
      .get('facilitators', {
        params: {
          name: name,
          email: email,
          nric: nric,
        },
      })
      .then((checkResponse) => {
        // If a facilitator with the same name and email is found, show an error message
        if (checkResponse.data.some(facilitator => facilitator.email === email)) {
          setError('Facilitator with the same email already exists.');
        }

        if (prooftype === 'NRIC' && checkResponse.data.some(facilitator => facilitator.nric === nric && facilitator.prooftype === 'NRIC')) {
          setError('Facilitator with the same NRIC already exists.');
          return; // Stop further processing if NRIC exists
        }

        // Check if the prooftype is 'FIN' and NRIC is already present for FIN proof type
        if (prooftype === 'FIN' && checkResponse.data.some(facilitator => facilitator.nric === nric && facilitator.prooftype === 'FIN')) {
          setError('Facilitator with the same FIN already exists.');
          return; // Stop further processing if NRIC exists for FIN proof type
        }

        else {
          // If no matching facilitator is found, proceed to create a new facilitator
          axios
            .post('facilitator', facilitator)
            .then((response) => {
              const newFacilitatorId = response.data.id;


              // Now, use the 'user' API endpoint to add user information
              const userData = {
                email: email,
                name: name,
                username: name,
                password,
                usertype: 2,
                sfid: newFacilitatorId,
              };


              // Make a POST request to the 'user' endpoint
              axios
                .post('auth/create-user', userData)
                .then((userResponse) => {
                  // console.log('User added successfully', userResponse.data);
                  navigate('/facilitor');
                  onFormSubmit();

                })
                .catch((userError) => {
                  console.error('Error adding user:', userError);
                  setError('Error adding user');
                });
            })
            .catch((error) => {
              console.error(error);
              setError('Error creating facilitator');
            });
        }

      })
      .catch((checkError) => {
        console.error(checkError);
        setError('Error checking facilitator');
      });



  }
  const [isFormDirty, setIsFormDirty] = useState(false);

  const handleInputChange = () => {
    if (!isFormDirty) {
      setIsFormDirty(true);
    }
  };


  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (isFormDirty) {
        event.preventDefault();
        event.returnValue = 'You have unsaved changes. Are you sure you want to leave this page?';
      }
    };



    window.addEventListener('beforeunload', handleBeforeUnload);


    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [isFormDirty]);


  const handleCancel = () => {


    {
      onFormSubmit();
    }
  };








  const handleConfirmSave = () => {
    setShowConfirmationModal(false);
    onFormSubmit();
  };








  const handleCancelSave = () => {
    setShowConfirmationModal(false);
  };






 const handleClickShowPassword = () => {
  setShowPassword((prev) => !prev);
};









  return (
    <div className="containerw mx-auto" style={{
      maxWidth: '1000px',
      background: '#ffffff',
      padding: '20px',
      boxShadow: '0px 0px 2px 0px #000000',
      borderRadius: '10px',
      marginBottom: '15px'
    }}>
      <h4> New Facilitator (Jurong Academy)</h4>
      <br />
      {error && <div className="text-danger">{error}</div>}


      <form onSubmit={onSubmit} onChange={handleInputChange} style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
        {/* LEFT SIDE */}
        <div style={{ flex: 1, minWidth: '300px' }}>
          <div className="form-group">
            <label>Salutation</label>
            <select
              className="form-control"
              name="salutation"
              value={facilitator.salutation}
              onChange={onInputChange}
              required
            >
              <option value="">Select Salutation</option>
              <option value="Mr.">Mr.</option>
              <option value="Ms.">Ms.</option>
            </select>
            {errors.salutation && <div className="text-danger">{errors.salutation}</div>}
          </div>

          <div className="form-group">
            <label>Name</label>
            <input
              type="text"
              name="name"
              className="form-control"
              value={facilitator.name}
              required
              maxLength={200}
              onChange={(e) => {
                if (e.target.value.length <= 200) onInputChange(e);
              }}
            />
            {(errors.name || !facilitator.name) && <div className="text-danger">{errors.name}</div>}
          </div>

          <div className="form-group">
            <label>Select ID Type</label>
            <select
              name="prooftype"
              className="form-control"
              value={facilitator.prooftype}
              onChange={onInputChange}
              required
            >
              <option value="">Select ID Type</option>
              <option value="NRIC">NRIC</option>
              <option value="FIN">FIN</option>
            </select>
            {!facilitator.prooftype && <p className="text-danger">ID Type is required.</p>}
          </div>

          {(facilitator.prooftype === 'NRIC' || facilitator.prooftype === 'FIN') && (
            <div className="form-group">
              <label>{facilitator.prooftype}</label>
              <input
                type="text"
                name="nric"
                className="form-control"
                value={facilitator.nric}
                onChange={onInputChange}
                maxLength={9}
                required
              />
              {errors.nric && <span className="text-danger">{errors.nric}</span>}
            </div>
          )}

          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              name="email"
              className="form-control"
              value={facilitator.email}
              onChange={onInputChange}
              required
            />
            {(errors.email || !facilitator.email) && <div className="text-danger">{errors.email}</div>}
          </div>
        </div>

        {/* RIGHT SIDE */}
        <div style={{ flex: 1, minWidth: '300px' }}>
          <div className="form-group">
            <label>Phone</label>
            <PhoneInput
              country="sg"
              value={facilitator.phone}
              onChange={(value, country) =>
                setFacilitator({
                  ...facilitator,
                  phone: `+${country.dialCode} ${value.slice(country.dialCode.length)}`,
                })
              }
              inputStyle={{ width: '100%' }}
              dropdownStyle={{ width: '250px' }}
              required
            />
            {(errors.phone || !facilitator.phone) && <div className="text-danger">{errors.phone}</div>}
          </div>

          <div className="form-group">
            <label>Qualification</label>
            <input
              type="text"
              name="qualification"
              className="form-control"
              value={facilitator.qualification}
              onChange={(e) => {
                const input = e.target.value;
                const onlyLetters = /^[A-Za-z\s]*$/;
                if ((input.length <= 50 && onlyLetters.test(input)) || input === "") {
                  setFacilitator((prev) => ({ ...prev, qualification: input }));
                }
              }}
              title="Only letters and spaces allowed"
              required
            />
            {(errors.qualification || !facilitator.qualification) && (
              <div className="text-danger">{errors.qualification}</div>
            )}
          </div>

         <div className="form-group" style={{ position: 'relative' }}>
  <label>Password</label>
  <input
    type={showPassword ? 'text' : 'password'}
    name="password"
    className="form-control"
    value={facilitator.password}
    onChange={onInputChange}
    autoComplete="new-password"
    required
    style={{ paddingRight: '40px' }} // space for icon
  />

  <IconButton
    onClick={handleClickShowPassword}
    onMouseDown={(e) => e.preventDefault()}
    style={{
      position: 'absolute',
      right: '10px',
      top: '31px', // adjust based on your label and input height
      padding: 0,
    }}
    size="small"
  >
    {showPassword ? <VisibilityOff /> : <Visibility />}
  </IconButton>

  {(errors.password || !facilitator.password) && (
    <div className="text-danger">{errors.password}</div>
  )}
</div>
          <div className="form-group">
            <label>Gender</label>
            <div>
              {['Male', 'Female', 'Other'].map((g) => (
                <div className="form-check" key={g}>
                  <input
                    type="radio"
                    className="form-check-input"
                    name="gender"
                    value={g}
                    checked={facilitator.gender === g}
                    onChange={onInputChange}
                    required
                  />
                  <label className="form-check-label">{g}</label>
                </div>
              ))}
            </div>
            {(errors.gender || !facilitator.gender) && <div className="text-danger">{errors.gender}</div>}
          </div>

          <div
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: '10px',
              marginTop: '20px',
              justifyContent: 'center', // Center on small screens
            }}
          >
            <button
              type="button"
              className="btn btn-danger"
              onClick={handleCancel}
              style={{
                borderRadius: '8px',
                padding: '10px 25px',
                minWidth: '120px',
                flex: '1 1 150px',
                backgroundColor: 'red'
              }}
            >
              Cancel
            </button>

            <button
              type="submit"
              className="btn btn-success d-flex align-items-center justify-content-center"
              style={{
                borderRadius: '8px',
                padding: '10px 20px',
                minWidth: '120px',
                flex: '1 1 150px',
                gap: '8px',
                backgroundColor: 'green'
              }}
            >
              <FaPlus /> Submit
            </button>
          </div>

        </div>
      </form>



    </div>
  );
}



const Batchess = ({ onFormSubmit }) => {
  return (
    <div>

      <NewFacilitator onFormSubmit={onFormSubmit} />
    </div>
  );
};


export default Batchess;

